import {
  ContractFilter,
  Contract,
  PaginationContractList,
  SortColumns,
  ContractSearch,
  ContractStatusId,
} from 'pricing/types';

export interface ContractListState extends ContractListSearchState {
  loading: boolean;
  contracts: Contract[];
  expandAllContracts: boolean;
}

export interface ContractListSearchState {
  search: ContractSearch;
  filters: ContractFilter;
  pagination: PaginationContractList;
  sort: SortColumns;
}

export const ContractListInitState: ContractListState = {
  loading: false,
  contracts: [],
  search: {
    breeder_contract_status_id: ContractStatusId.Active,
  },
  filters: {},
  sort: {},
  pagination: {
    currentPage: 1,
    totalContracts: 0,
    pageSize: 25,
  },
  expandAllContracts: false,
};

export type ContractListingAction =
  | { type: 'LOAD_CONTRACTS' }
  | {
      type: 'SET_CONTRACTS';
      payload: {
        contracts: Contract[];
        pagination: PaginationContractList;
      };
    }
  | { type: 'FILTER_CONTRACTS'; payload: ContractFilter }
  | { type: 'SEARCH_CONTRACTS'; payload: ContractSearch }
  | { type: 'SORT_CONTRACTS'; payload: SortColumns }
  | { type: 'PAGE_CONTRACTS'; payload: PaginationContractList }
  | { type: 'EXPAND_ALL_CONTRACTS'; payload: boolean };

export const contractsListReducer = (
  state: ContractListState,
  action: ContractListingAction,
): ContractListState => {
  switch (action.type) {
    case 'LOAD_CONTRACTS': {
      return { ...state, loading: true };
    }
    case 'SET_CONTRACTS': {
      const { contracts, pagination } = action.payload;
      return {
        ...state,
        loading: false,
        contracts: contracts,
        pagination: pagination,
      };
    }
    case 'FILTER_CONTRACTS': {
      const filters = { ...action.payload };
      return {
        ...state,
        filters,
        pagination: {
          currentPage: 1,
          totalContracts: state.pagination.totalContracts,
          pageSize: state.pagination.pageSize,
        },
      };
    }

    case 'SEARCH_CONTRACTS': {
      const search = { ...action.payload };
      return {
        ...state,
        search,
        pagination: {
          currentPage: 1,
          totalContracts: state.pagination.totalContracts,
          pageSize: state.pagination.pageSize,
        },
      };
    }

    case 'SORT_CONTRACTS': {
      const sort = { ...action.payload };
      return {
        ...state,
        sort,
        pagination: {
          currentPage: 1,
          totalContracts: state.pagination.totalContracts,
          pageSize: state.pagination.pageSize,
        },
        expandAllContracts: false,
      };
    }

    case 'PAGE_CONTRACTS': {
      const pagination = { ...action.payload };
      return {
        ...state,
        pagination: {
          currentPage: pagination.currentPage,
          totalContracts: state.pagination.totalContracts,
          pageSize: pagination.pageSize,
        },
        expandAllContracts: false,
      };
    }
    case 'EXPAND_ALL_CONTRACTS': {
      const expand = { ...action };
      return {
        ...state,
        expandAllContracts: expand.payload,
      };
    }
    default:
      return state;
  }
};
